// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__FsCPd","list":"MainNavigation_list__AcSCF","active":"MainNavigation_active__1QQOQ","logo":"MainNavigation_logo__7oxkl"};